import React from 'react';
import { ReactComponent as HomeIcon } from '../../../assets/icons/Home.svg';
import { ReactComponent as HomeIconWhite } from '../../../assets/icons/Home-w.svg';
import { ReactComponent as MacIcon } from '../../../assets/icons/Display.svg';
import { ReactComponent as MacIconWhite } from '../../../assets/icons/Display-w.svg';
import { ReactComponent as RadioBtnIconWhite } from '../../../assets/icons/Radiobutton-active.svg';
import { ReactComponent as RadioBtnIcon } from '../../../assets/icons/Radiobutton.svg';
import { ReactComponent as HistoryIcon } from '../../../assets/icons/History.svg';
import { ReactComponent as HistoryIconWhite } from '../../../assets/icons/History-w.svg';
import { ReactComponent as BuildingsIcon } from '../../../assets/icons/Buildings.svg';
import { ReactComponent as BuildingsIconWhite } from '../../../assets/icons/Buildings-w.svg';
import { LocationType } from '../../../types/apiGeneratedTypes';

type Props = {
  onLocationBtnClick: (location: LocationType) => void;
  currentLocationOption: LocationType;
  membershipType?: string | null;
};

const LocationButtons = ({
  onLocationBtnClick,
  currentLocationOption,
  membershipType
}: Props) => {
  const isCoreMember = membershipType?.toLowerCase() === 'core';

  const btnClass = (location: LocationType) =>
    `location-btn ${currentLocationOption === location ? 'active' : ''}`;

  return (
    <>
      <div
        className={btnClass(LocationType.CLINIC)}
        onClick={() => onLocationBtnClick(LocationType.CLINIC)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.CLINIC ? (
            <HomeIconWhite />
          ) : (
            <HomeIcon />
          )}
          {currentLocationOption === LocationType.CLINIC ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Blood Clinic</span>
      </div>

      <div
        className={btnClass(LocationType.ONLINE)}
        onClick={() => onLocationBtnClick(LocationType.ONLINE)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.ONLINE ? (
            <MacIconWhite />
          ) : (
            <MacIcon />
          )}
          {currentLocationOption === LocationType.ONLINE ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Online</span>
      </div>

      <div
        className={btnClass(LocationType.HISTORICRESULTS)}
        onClick={() => onLocationBtnClick(LocationType.HISTORICRESULTS)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.HISTORICRESULTS ? (
            <HistoryIconWhite style={{ height: '40px', width: '40px' }} />
          ) : (
            <HistoryIcon
              className='radio-btn'
              style={{ height: '40px', width: '40px' }}
            />
          )}
          {currentLocationOption === LocationType.HISTORICRESULTS ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Historic Results</span>
      </div>

      <div
        className={btnClass(LocationType.MEMBER_HOME)}
        onClick={() => onLocationBtnClick(LocationType.MEMBER_HOME)}
      >
        <div className='icons'>
          {currentLocationOption === LocationType.MEMBER_HOME ? (
            <HomeIconWhite />
          ) : (
            <HomeIcon />
          )}
          {currentLocationOption === LocationType.MEMBER_HOME ? (
            <RadioBtnIconWhite className='radio-btn' />
          ) : (
            <RadioBtnIcon className='radio-btn' />
          )}
        </div>
        <span>Blood Home Visit</span>
      </div>

      {!isCoreMember && (
        <div
          className={btnClass(LocationType.SCAN)}
          onClick={() => onLocationBtnClick(LocationType.SCAN)}
        >
          <div className='icons'>
            {currentLocationOption === LocationType.SCAN ? (
              <BuildingsIconWhite style={{ height: '40px', width: '40px' }} />
            ) : (
              <BuildingsIcon style={{ height: '40px', width: '40px' }} />
            )}
            {currentLocationOption === LocationType.SCAN ? (
              <RadioBtnIconWhite className='radio-btn' />
            ) : (
              <RadioBtnIcon className='radio-btn' />
            )}
          </div>
          <span>Scan</span>
        </div>
      )}
    </>
  );
};

export default LocationButtons;
